import script from "./TagPicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./TagPicker.vue?vue&type=script&setup=true&lang=ts"

import "./TagPicker.vue?vue&type=style&index=0&id=8412d08a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8412d08a"]])

export default __exports__